module.exports = __webpack_public_path__ + "static/media/loss_of_smell.723d4ce7.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/symptoms/loss_of_smell.png
// module id = 406
// module chunks = 0